import type { WorkbookName } from 'cadenza/repository/model/workbook-name.gen';
import type { WorkbookHash } from 'cadenza/workbook/model/workbook-hash';

/**
 * An object holding the id and a hash representing a state of the workbook.
 *
 * @see net/disy/cadenza/repository/api/workbook/WorkbookNameAndHash.java
 */
export interface WorkbookNameAndHash {
  /** The id of the workbook. */
  id: WorkbookName;
  /** The hash to identify the workbook state. */
  hash: WorkbookHash;
}

// This is `string` instead of `Opaque<'WorkbookNameAndHashString', string>`
// because the result is expected to end up somewhere that expects `string` anyway.
export type WorkbookNameAndHashString = string;

/**
 * Converts the `workbookNameAndHash` to the string representation used in URL path components.
 *
 * @param workbookNameAndHash - name and hash
 * @return string representation of workbook name and hash
 */
export function workbookNameAndHashString(workbookNameAndHash: WorkbookNameAndHash): WorkbookNameAndHashString {
  return `${workbookNameAndHash.id},hash=${workbookNameAndHash.hash}`;
}
